import { render, staticRenderFns } from "./MilestoneAttachments.vue?vue&type=template&id=3ccc4476"
import script from "./MilestoneAttachments.vue?vue&type=script&lang=js"
export * from "./MilestoneAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports